export default __webpack_public_path__ + "static/media/light-bulb.a8423d9c.jpg";